import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import './MapSelector.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const MapSelector = ({ onLocationChange, initLat, initLon }) => {
  const [position, setPosition] = useState([initLat, initLon]);

  useEffect(() => {
    setPosition([initLat, initLon]);
  }, [initLat, initLon]);

  function LocationMarker() {
    const map = useMap();

    useEffect(() => {
      map.setView(position, map.getZoom());
    }, [map]);

    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition([lat, lng]);
        onLocationChange(lat, lng);
      },
    });

    return <Marker position={position} draggable={true}
      eventHandlers={{
        dragend: (e) => {
          const marker = e.target;
          const { lat, lng } = marker.getLatLng();
          setPosition([lat, lng]);
          onLocationChange(lat, lng);
        },
      }}
    />;
  }

  return (
    <div id='map-selector' className='map'>
      <MapContainer center={position} zoom={13} style={{ height: "400px", width: "600px" }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        <LocationMarker />
      </MapContainer>
    </div>
  );
};

export default MapSelector;
